import React from 'react';
import store from 'store2';
import PropTypes from 'prop-types';
import { Grid, Header, Icon, Image } from 'semantic-ui-react';
import { connect } from 'react-redux';
import Login from '../../components/Login';
import Signup from '../Signup';
import Footer from '../../components/Mainfooter';
import { Images } from '../../style';
import { Link, withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import { getQueryParams } from '../../helpers/commonHelper';


const Shopify = withRouter(({ location }) => {
  let shopifyAccessToken = '';
  let shopifyStore = '';
  if (location.search) {
    const res = getQueryParams(location.search);
    if(res) {
      if(res.shopifyToken) {
        shopifyAccessToken = res.shopifyToken;
        shopifyStore = res.store;
      }
    }
  }
  return (
    <div className="height login-bg">
    <Grid className="full-height">
      <Grid.Row divided centered  >
        <Grid.Column mobile={14} tablet={7} computer={7}>
          <a href="https://www.videopeel.com/" >
            <Image className="logo" src={Images.logo} centered/>
          </a>
          <Login
            location = {location}
            shopifyToken={shopifyAccessToken}
            shopifyStore={shopifyStore}/>
        </Grid.Column>
      </Grid.Row>
    </Grid>
    <Footer/>
    </div>
  );
});

Shopify.propTypes = {
  user: PropTypes.object,
};

Shopify.defaultProps = {
  user: null,
};

export default connect(state => ({
  user: state.get('auth').get('user'),
}))(Shopify);



// WEBPACK FOOTER //
// ./src/containers/Shopify/Shopify.js